export default __webpack_public_path__ + "static/media/adriana-team.e6f96fa7.png";